// https://stackoverflow.com/questions/15458876/check-if-a-string-is-html-or-not/15458987
export function isHTMLElement(str: string) {
  const doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
}

export function isValid(item: any) {
  return !([undefined, null].includes(item) || isHTMLElement(item));
}
